import JobStatusApi from "../generated/api/JobStatusApi";

class JobStatusService {
  constructor() {
    this.JobStatusApi = new JobStatusApi();
  }

  async getAllJobStatuses() {
    return await window.$A.HandleApiResponse(
      this.JobStatusApi.getJobStatusesByAccount(),
      ""
    );
  }

  async createJobStatus(createJobStatusRequest) {
    return await window.$A.HandleApiResponse(
      this.JobStatusApi.createJobStatus({ createJobStatusRequest }),
      "Job Status Created"
    );
  }

  async updateJobStatus(updateJobStatusRequest) {
    return await window.$A.HandleApiResponse(
      this.JobStatusApi.updateStatus({ updateJobStatusRequest }),
      "Job Status Updated"
    );
  }

  async replaceAndDeleteJobStatus(deleteStatusAndTransferJobs) {
    return await window.$A.HandleApiResponse(
      this.JobStatusApi.replaceAndDeleteStatus({ deleteStatusAndTransferJobs }),
      "Job Status Deleted and Replaced"
    );
  }
}

export default JobStatusService;
